import React, { useState } from 'react';
import { GridIcon, ListIcon, BookmarkIcon, AwardIcon, ClipboardIcon } from 'lucide-react';
interface ProfileTabsProps {
  userId: string;
}
const ProfileTabs: React.FC<ProfileTabsProps> = ({
  userId
}) => {
  const [activeTab, setActiveTab] = useState('posts');
  const tabs = [{
    id: 'posts',
    icon: GridIcon,
    label: 'Posts'
  }, {
    id: 'highlights',
    icon: ListIcon,
    label: 'Highlights'
  }, {
    id: 'saved',
    icon: BookmarkIcon,
    label: 'Saved'
  }, {
    id: 'achievements',
    icon: AwardIcon,
    label: 'Achievements'
  }, {
    id: 'resume',
    icon: ClipboardIcon,
    label: 'Resume'
  }];
  const postImages = ['https://images.unsplash.com/photo-1517466787929-bc90951d0974', 'https://images.unsplash.com/photo-1560272564-c83b66b1ad12', 'https://images.unsplash.com/photo-1579952363873-27f3bade9f55', 'https://images.unsplash.com/photo-1574629810360-7efbbe195018', 'https://images.unsplash.com/photo-1431324155629-1a6deb1dec8d', 'https://images.unsplash.com/photo-1461896836934-ffe607ba8211', 'https://images.unsplash.com/photo-1518091043644-c1d4457512c6', 'https://images.unsplash.com/photo-1577741314755-048d8525d31e', 'https://images.unsplash.com/photo-1551958219-acbc608c6377'];
  return <div data-id="element-519">
      {/* Tabs */}
      <div className="flex border-b border-gray-200" data-id="element-520">
        {tabs.map(tab => <button key={tab.id} className={`flex-1 flex flex-col items-center py-3 text-xs tab ${activeTab === tab.id ? 'tab-active' : 'tab-inactive'}`} onClick={() => setActiveTab(tab.id)} data-id="element-521">
            <tab.icon size={18} className="mb-1" data-id="element-522" />
            {tab.label}
          </button>)}
      </div>
      {/* Content */}
      <div className="p-1" data-id="element-523">
        {activeTab === 'posts' && <div className="grid grid-cols-3 gap-1" data-id="element-524">
            {postImages.map((image, index) => <div key={index} className="aspect-square relative rounded-md overflow-hidden" data-id="element-525">
                <img src={image} alt={`Post ${index + 1}`} className="w-full h-full object-cover" data-id="element-526" />
                {index % 3 === 0 && <div className="absolute top-2 right-2" data-id="element-527">
                    <svg className="w-4 h-4 text-white drop-shadow-md" fill="currentColor" viewBox="0 0 20 20" data-id="element-528">
                      <path d="M2 6a2 2 0 012-2h6a2 2 0 012 2v8a2 2 0 01-2 2H4a2 2 0 01-2-2V6z" data-id="element-529"></path>
                      <path d="M10 6a2 2 0 012-2h4a2 2 0 012 2v8a2 2 0 01-2 2h-4a2 2 0 01-2-2V6z" data-id="element-530"></path>
                    </svg>
                  </div>}
                {index % 5 === 0 && <div className="absolute top-2 right-2" data-id="element-531">
                    <svg className="w-4 h-4 text-white drop-shadow-md" fill="currentColor" viewBox="0 0 20 20" data-id="element-532">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" data-id="element-533"></path>
                    </svg>
                  </div>}
              </div>)}
          </div>}
        {activeTab === 'highlights' && <div className="flex flex-col items-center justify-center py-10" data-id="element-534">
            <ListIcon size={40} className="text-gray-300 mb-2" data-id="element-535" />
            <p className="text-gray-500 text-sm" data-id="element-536">Highlights will appear here</p>
          </div>}
        {activeTab === 'saved' && <div className="flex flex-col items-center justify-center py-10" data-id="element-537">
            <BookmarkIcon size={40} className="text-gray-300 mb-2" data-id="element-538" />
            <p className="text-gray-500 text-sm" data-id="element-539">
              Saved posts will appear here
            </p>
          </div>}
        {activeTab === 'achievements' && <div className="p-4" data-id="element-540">
            <div className="flex items-center justify-between p-3 bg-orange-50 rounded-lg mb-3" data-id="element-541">
              <div className="flex items-center" data-id="element-542">
                <div className="bg-orange-100 p-2 rounded-full mr-3" data-id="element-543">
                  <AwardIcon size={24} className="text-orange-600" data-id="element-544" />
                </div>
                <div data-id="element-545">
                  <h3 className="font-medium" data-id="element-546">League Champion 2023</h3>
                  <p className="text-xs text-gray-500" data-id="element-547">National League</p>
                </div>
              </div>
              <div className="bg-orange-200 text-orange-800 text-xs font-medium px-2 py-1 rounded-full" data-id="element-548">
                Verified
              </div>
            </div>
            <div className="flex items-center justify-between p-3 bg-indigo-50 rounded-lg" data-id="element-549">
              <div className="flex items-center" data-id="element-550">
                <div className="bg-indigo-100 p-2 rounded-full mr-3" data-id="element-551">
                  <AwardIcon size={24} className="text-indigo-600" data-id="element-552" />
                </div>
                <div data-id="element-553">
                  <h3 className="font-medium" data-id="element-554">Top Scorer</h3>
                  <p className="text-xs text-gray-500" data-id="element-555">Regional Tournament</p>
                </div>
              </div>
              <div className="bg-indigo-200 text-indigo-800 text-xs font-medium px-2 py-1 rounded-full" data-id="element-556">
                Verified
              </div>
            </div>
          </div>}
        {activeTab === 'resume' && <div className="p-4" data-id="element-557">
            <div className="mb-4" data-id="element-558">
              <h3 className="font-medium text-sm text-gray-500 uppercase mb-2" data-id="element-559">
                Current
              </h3>
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-560">
                <div className="flex items-center" data-id="element-561">
                  <img src="https://images.unsplash.com/photo-1522778119026-d647f0596c20" alt="Team logo" className="w-10 h-10 rounded-full mr-3" data-id="element-562" />
                  <div data-id="element-563">
                    <h4 className="font-medium" data-id="element-564">Forward at FC Barcelona</h4>
                    <p className="text-xs text-gray-500" data-id="element-565">2022 - Present</p>
                  </div>
                </div>
              </div>
            </div>
            <div data-id="element-566">
              <h3 className="font-medium text-sm text-gray-500 uppercase mb-2" data-id="element-567">
                Previous
              </h3>
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100 mb-2" data-id="element-568">
                <div className="flex items-center" data-id="element-569">
                  <img src="https://images.unsplash.com/photo-1574629810360-7efbbe195018" alt="Team logo" className="w-10 h-10 rounded-full mr-3" data-id="element-570" />
                  <div data-id="element-571">
                    <h4 className="font-medium" data-id="element-572">Forward at Manchester City</h4>
                    <p className="text-xs text-gray-500" data-id="element-573">2019 - 2022</p>
                  </div>
                </div>
              </div>
              <div className="bg-white p-3 rounded-lg shadow-sm border border-gray-100" data-id="element-574">
                <div className="flex items-center" data-id="element-575">
                  <img src="https://images.unsplash.com/photo-1589487391730-58f20eb2c308" alt="Team logo" className="w-10 h-10 rounded-full mr-3" data-id="element-576" />
                  <div data-id="element-577">
                    <h4 className="font-medium" data-id="element-578">Youth Player at Monaco FC</h4>
                    <p className="text-xs text-gray-500" data-id="element-579">2015 - 2019</p>
                  </div>
                </div>
              </div>
            </div>
          </div>}
      </div>
    </div>;
};
export default ProfileTabs;